import {
  USERS_LIST,
  USERS_LIST_SUCCESS,
  USERS_LIST_ERROR,
  USERS_NEW,
  USERS_NEW_SUCCESS,
  USERS_NEW_ERROR,
  USERS_EDIT,
  USERS_DELETE,
  USERS_DELETE_SUCCESS,
  USERS_DELETE_ERROR,
  USERS_BLOCK,
  USERS_BLOCK_SUCCESS,
  USERS_BLOCK_ERROR,
} from "./actionTypes"

const initialState = {
  responseList: "",
  loadingList: false,
  errorList: "",
  responseNew: "",
  loadingNew: false,
  errorNew: "",
  responseDelete: "",
  loadingDelete: false,
  errorDelete: "",
  responseBlock: "",
  loadingBlock: false,
  errorBlock: "",
}

const Users = (state = initialState, action) => {
  switch (action.type) {
    case USERS_LIST:
      state = {
        ...state,
        loadingList: true,
        errorList: "",
      }
      break
    case USERS_LIST_SUCCESS:
      state = {
        ...state,
        loadingList: false,
        responseList: action.payload.data
      }
      break
    case USERS_LIST_ERROR:
      state = {
        ...state,
        loadingList: false,
        errorList: action.payload
      }
      break
    case USERS_NEW:
      state = {
        ...state,
        loadingNew: true,
        responseNew: "",
        errorNew: ""
      }
      break
    case USERS_NEW_SUCCESS:
      state = {
        ...state,
        loadingNew: false,
        responseNew: action.payload.data
      }
      break
    case USERS_NEW_ERROR:
      state = {
        ...state,
        loadingNew: false,
        errorNew: action.payload
      }
      break
    case USERS_EDIT:
      state = {
        ...state,
        loadingNew: true,
        responseNew: "",
        errorNew: ""
      }
      break
    case USERS_DELETE:
      state = {
        ...state,
        loadingDelete: true,
        responseDelete: "",
        errorDelete: ""
      }
      break
    case USERS_DELETE_SUCCESS:
      state = {
        ...state,
        loadingDelete: false,
        responseDelete: action.payload.data
      }
      break
    case USERS_DELETE_ERROR:
      state = {
        ...state,
        loadingDelete: false,
        errorDelete: action.payload
      }
      break
    case USERS_BLOCK:
      state = {
        ...state,
        loadingBlock: true,
        responseBlock: "",
        errorBlock: ""
      }
      break
    case USERS_BLOCK_SUCCESS:
      state = {
        ...state,
        loadingBlock: false,
        responseBlock: action.payload.data
      }
      break
    case USERS_BLOCK_ERROR:
      state = {
        ...state,
        loadingBlock: false,
        errorBlock: action.payload
      }
      break
    default:
      state = {...state}
      break
  }
  return state
}

export default Users
